import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateFromHTML } from "draft-js-import-html";
import "./Editor.scss";

const content = {
  entityMap: {},
  blocks: [   
    {
      key: "637gr",
      text: "",
      type: "unstyled",   
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
};

function TextEditor(props) {
  const [contentState, setContentState] = useState(convertFromRaw(content));
  const [editorState, setEditorState] = useState(
    props && props.htmlData
      ? EditorState.createWithContent(stateFromHTML(props.htmlData))
      : EditorState.createEmpty()
  );

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    if (props.getHtmlData) {
      let currentContentAsHTML = convertToHTML({
        blockToHTML: (block) => {
          if (block.type === "code") {
            return <pre />;
          }
        },
      })(editorState.getCurrentContent());
      props.getHtmlData(currentContentAsHTML);
    }
  };

  const handleContentChange = (contentState) => {
    setContentState(contentState);
    if (props.onChange) {
      props.onChange(contentState.blocks[0].text);
    }
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    props.getHtmlData(currentContentAsHTML);
  };

  return (
    <>
      <Editor
        editorState={editorState}
        wrapperClassName="custom-editor-wrapper"
        editorClassName="custom-editor px-3"
        toolbarClassName="custom-editor-toolbar bg-transparent px-0"
        onEditorStateChange={onEditorStateChange}
        onContentStateChange={handleContentChange}
        toolbar={{
          options: ["inline", "list"],
          inline: {
            inDropdown: false,
            bold: { className: "text-grey-4 px-2" },
            italic: { className: "text-grey-4 px-2" },
            strikethrough: { className: "d-none" },
            monospace: { className: "d-none" },
            superscript: { className: "d-none" },
            subscript: { className: "d-none" },
          },
          list: {
            options: ["unordered", "ordered"],
            unordered: { className: "text-grey-4 px-2" },
            ordered: { className: "text-grey-4 px-2" },
          },
          link: {
            link: { className: undefined },
            unlink: { className: "d-none" },
          },
        }}
        editorStyle={{
          minHeight: `{${props && props.editorHeight}?${
            props && props.editorHeight
          }:"250px"}`,
        }}
      />
    </>
  );
}

export default TextEditor;
